/**
 * @generated SignedSource<<0025125d0467645c67516db6ee0c589f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node$data = {
  readonly __typename: "WorkSuggestionsPRCommentsTask";
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestCommentSuggestions_periscope_PullRequestCommentTask">;
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node";
};
export type suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node$key = {
  readonly " $data"?: suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "pullRequestCommentSuggestions_periscope_PullRequestCommentTask"
        }
      ],
      "type": "WorkSuggestionsPRCommentsTask"
    }
  ],
  "type": "WorkSuggestionsPeriscopeTask",
  "abstractKey": "__isWorkSuggestionsPeriscopeTask"
};

(node as any).hash = "278331effe1ac05d93d3b9a70f4facdb";

export default node;
